import React, { useImperativeHandle, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import { indexOf } from "lodash";
import { Box, Icons, Typography } from '@curves/ui-base';


import RadioChip from "@Local/Dashboard/Components/RadioChip";
const DataTypeSection = React.forwardRef((props, ref) => {
    const {
        mainGroupType,
        subGroupType,
        label, dataTypeOptions, defaultSelected, disabled
    } = props;
    const [checkedCount, setCheckedCount] = useState(defaultSelected.length);
    const chipRefs = useRef({});
    const iconColor = disabled ? 'gray' : 'primary';
    const handleClickSelectType = () => {
        if (disabled) return;
        if (checkedCount < dataTypeOptions.length) {
            setCheckedCount(dataTypeOptions.length);
            dataTypeOptions.forEach((option) => {
                chipRefs.current[option.dataType].setChecked(true);
            });
        } else {
            setCheckedCount(0);
            dataTypeOptions.forEach((option) => {
                chipRefs.current[option.dataType].setChecked(false);
            });
        }
    };
    const handleChipChange = () => {
        const newCheckedCount = dataTypeOptions.filter(option =>
            chipRefs.current[option.dataType]?.checked()
        ).length;
        setCheckedCount(newCheckedCount);
    };
    const SectionIcon = useMemo(
        () => {
            const props = {
                color: iconColor,
                fontSize: 'small',
                className: clsx('tag-type-selector-box', { 'cursor-pointer': !disabled }),
                onClick: handleClickSelectType
            }
            if (checkedCount === 0) {
                return <Icons.CheckBoxOutlineBlank {...props} />;
            } else if (checkedCount === dataTypeOptions.length) {
                return <Icons.CheckBox {...props} />;
            } else {
                return <Icons.IndeterminateCheckBox {...props} />;
            }
        },
        // eslint-disable-next-line
        [checkedCount, disabled]
    );
    useImperativeHandle(ref, () => ({
        getResult: () => {
            const result = [];
            dataTypeOptions.forEach((option) => {
                const { dataType, dataTypeText } = option;
                if (chipRefs.current[dataType].checked())
                    result.push({ mainGroupType, subGroupType, dataType, dataTypeText });
            });
            return result;
        }
    }));
    return (
        <Box>
            <Typography>
                {SectionIcon}
                {label}
            </Typography>
            <Box className="data-type-selector-box">
                {dataTypeOptions && dataTypeOptions.length > 0 && (
                    dataTypeOptions.map((option) => {
                        const { dataType, dataTypeText } = option;
                        return (
                            <RadioChip key={dataType}
                                       label={dataTypeText}
                                       defaultChecked={indexOf(defaultSelected, dataType) !== -1}
                                       ref={(el) => (chipRefs.current[dataType] = el)}
                                       disabled={disabled}
                                       onChange={handleChipChange}
                            />
                        );
                    })
                )}
            </Box>
        </Box>
    );
});
export default DataTypeSection;